import React from "react";
import { Form } from "react-bootstrap";
export const CreateActivityText: React.FC<{
  label: string;
  register: any;
  type: string;
  error?: any;
  columnClass?: string;
}> = (props) => {
  return (
    <Form.Group
      className={`${props.columnClass ? props.columnClass : "col-md-6"}`}
    >
      <Form.Label>{props.label}</Form.Label>
      <Form.Control
        {...props.register}
        type={props.type}
        isInvalid={Boolean(props.error)}
      />
      <Form.Control.Feedback type="invalid">
        {props?.error?.message}
      </Form.Control.Feedback>
    </Form.Group>
  );
};

export const SelectInp: React.FC<{
  label: string;
  error: any;
  register: any;
  options: Array<{
    label: string;
    value: any;
  }>;
}> = (props) => {
  return (
    <>
      <Form.Group className="col-md-6">
        <Form.Label>{props.label}</Form.Label>
        <Form.Select {...props.register} isInvalid={Boolean(props.error)}>
          {props.options.map((option, index) => (
            <option value={option.value} key={index}>
              {option.label}
            </option>
          ))}
        </Form.Select>
        <Form.Control.Feedback type="invalid">
          {props?.error?.message}
        </Form.Control.Feedback>
      </Form.Group>
    </>
  );
};
